<template>
    <div ref="container" style="position: relative; margin: auto;"
    :style="showBubbleContents? 'height: 700px; width: 700px;': 'height: 400px; width: 400px;'">
        <!-- Center bubble -->
        <div :style="{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: `${diameter}px`,
            height: `${diameter}px`,
            borderRadius: '50%',
            background: 'white',
            boxShadow: 'inset 0px 2px 10px rgba(0,0,0,0.1)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '12px',
            zIndex: 100,
        }">
            Key Subjects
        </div>

        <!-- Surrounding bubbles -->
            <div v-for="(bubble, index) in positionedBubbles" :key="index">
            <div  :style="{
                position: 'absolute',
                width: `${diameter}px`,
                height: `${diameter}px`,
                borderRadius: '50%',
                background: '#D7F5E9',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                boxShadow: 'inset 0px 2px 10px rgba(0,0,0,0.1)',
                fontSize: '12px',
                wordWrap: 'break-word',
                zIndex: 100,
                top: `calc(50% + ${bubble.y}px)`,
                left: `calc(50% + ${bubble.x}px)`,
                transform: 'translate(-50%, -50%)',
                backgroundColor: `${bubble.backgroundColor}`,
            }">
                {{ formatLabel(bubble?.name) }}
            </div>
            <!-- corresponding contents to bubbles -->
            <div v-if="showBubbleContents"
            style="position: absolute;
                width: 150px;
                border-radius: 16px;
                background: #D7F5E9;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 8px;
                box-shadow: 0px 2px 8px 0px #0000001A;
                font-size: 12px;
                word-wrap: break-word;
                z-index:100;"
                :style="{
                top: `calc(50% + ${bubble.contentsY}px)`,
                left: `calc(50% + ${bubble.contentsX}px)`,
                transform: 'translate(-50%, -50%)',
                backgroundColor: `${bubble.backgroundColor}`,
                }"
            >
            <ul>
                <li v-for="(topic, index) in bubble?.topics" :key="index" style="color: #666666;">{{topic}}</li>
            </ul>
            </div>
            <!-- SVG layer for connectors -->
            <svg style="position:absolute; top:0; left:0; width:100%; height:100%; pointer-events:none; z-index:1">
                <line
                v-for="(bubble, index) in positionedBubbles"
                :key="'line-'+index"
                :x1="containerCenter.x + bubble.x"    
                :y1="containerCenter.y + bubble.y"
                :x2="showBubbleContents? containerCenter.x + bubble.contentsX : containerCenter.x"
                :y2="showBubbleContents? containerCenter.y + bubble.contentsY : containerCenter.y"
                stroke="#666666"
                stroke-width="1"
                />
            </svg>
            </div>
    </div>
</template>
<script>
const DEFAULT_DIAMETER = 100;
const UPPER_BOUND_RADIUS = 160;

export default {
    name: 'RadialBubbleChart',
    props:{
        showBubbleContents: {
            type: Boolean,
            required: true,
            default: false,
        },
        bubbles: {
            type: Array,
            required: true,
            default: ()=>[],
        },
        diameter: {
            type: Number,
            default: DEFAULT_DIAMETER,
        },
    },
    data(){
        return{
            containerCenter: {},
            positionedBubbles:[],
            bubbleColorMap: ['#CDF3E2', '#DFEBFC', '#FFCDD6', '#F6DBFF', '#FFE5CA', '#FFC5DC'],
        }
    },
    async mounted(){
        const radius = this.computeBubbleRadius(this.bubbles.length);
        this.positionedBubbles = this.getRadialBubblePosition(this.bubbles, radius);
    },
    methods: {
        getRadialBubblePosition(bubbles,radius){
            const rect = this.$refs.container.getBoundingClientRect();
            this.containerCenter = { x: rect.width / 2, y: rect.height / 2 };

            return bubbles.map((bubble, index)=>{
                const angle = 2*Math.PI * (index + 1)/bubbles?.length + Math.PI/2;
                return {
                    x: radius*Math.cos(angle),
                    y: radius*Math.sin(angle),
                    contentsX: 2.5*radius*Math.cos(angle),
                    contentsY: 2.5*radius*Math.sin(angle),
                    backgroundColor: this.bubbleColorMap[index % this.bubbleColorMap?.length],
                    ...bubble
                }
            })
        },
        computeBubbleRadius(n) {
            const lowerBoundRadius = this.diameter + 10;

            if (this.showBubbleContents || n <= 2) return lowerBoundRadius;

            let computedRadius = 1.2 * (this.diameter / (2 * Math.sin(Math.PI / n)));
            computedRadius = this.clamp(computedRadius, lowerBoundRadius, UPPER_BOUND_RADIUS);
            return computedRadius;
        },
        clamp(value, min, max) {
            return Math.max(min, Math.min(max, value));
        },
        formatLabel(label) {
            // adds space around '/'
            return label ? label.replace(/\//g, '/ ') : '';
        }

    }
}
</script>
<style scoped></style>